(function(){
  var $ = function(s,c){return (c||document).querySelector(s)};
  var $$ = function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Rotador genérico: items con clase is-on
  function rotator(items, ms, dots){
    if(items.length<2) return null;
    var i=0, t=null;
    function go(j){ i=(j+items.length)%items.length; items.forEach(function(el,k){el.classList.toggle('is-on',k===i)}); if(dots) dots.forEach(function(d,k){d.classList.toggle('is-on',k===i); d.setAttribute('aria-current',k===i?'true':'false')}); }
    function play(){ stop(); if(!calm) t=setInterval(function(){go(i+1)},ms); }
    function stop(){ if(t) clearInterval(t); t=null; }
    play();
    return {go:function(j){go(j);play()}, next:function(){go(i+1);play()}, prev:function(){go(i-1);play()}, stop:stop, play:play};
  }

  // Barra de avisos
  var bar=$('[data-nv-bar]');
  if(bar){
    var r=rotator($$('.nv-bar__msg',bar),4000);
    if(r){ $('[data-nv-bar-prev]',bar).addEventListener('click',r.prev); $('[data-nv-bar-next]',bar).addEventListener('click',r.next); }
  }

  // Header con sombra al bajar
  var head=$('.nv-head');
  if(head){ var onS=function(){head.classList.toggle('is-scrolled',window.scrollY>8)}; window.addEventListener('scroll',onS,{passive:true}); onS(); }

  // Menú móvil
  var dr=$('[data-nv-drawer]');
  if(dr){
    var open=function(){dr.classList.add('is-open');dr.setAttribute('aria-hidden','false');document.documentElement.style.overflow='hidden';var f=$('a',dr);if(f)f.focus()};
    var close=function(){dr.classList.remove('is-open');dr.setAttribute('aria-hidden','true');document.documentElement.style.overflow=''};
    $$('[data-nv-open-menu]').forEach(function(b){b.addEventListener('click',open)});
    $$('[data-nv-close-menu]',dr).forEach(function(b){b.addEventListener('click',close)});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close()});
  }

  // Carrito lateral desde el header
  $$('[data-nv-cart]').forEach(function(a){a.addEventListener('click',function(e){ if(window.nsCarrito){e.preventDefault();window.nsCarrito.abrir(false)} })});

  // Portada
  var hero=$('[data-nv-hero]');
  if(hero){
    var dots=$$('.nv-hdot',hero);
    var hr=rotator($$('.nv-hero__slide',hero),4500,dots);
    if(hr) dots.forEach(function(d,k){d.addEventListener('click',function(){hr.go(k)})});
  }

  // Galería en tarjetas de producto
  $$('[data-nv-card]').forEach(function(c){
    var imgs=$$('.nv-card__img',c), dots=$$('.nv-dot',c), i=0;
    if(imgs.length<2) return;
    function go(j){ i=(j+imgs.length)%imgs.length; imgs.forEach(function(el,k){el.classList.toggle('is-on',k===i); if(k===i&&el.dataset.src){el.src=el.dataset.src;el.removeAttribute('data-src')}}); dots.forEach(function(d,k){d.classList.toggle('is-on',k===i)}); }
    var p=$('.nv-arr--l',c), n=$('.nv-arr--r',c);
    if(p) p.addEventListener('click',function(e){e.preventDefault();go(i-1)});
    if(n) n.addEventListener('click',function(e){e.preventDefault();go(i+1)});
    dots.forEach(function(d,k){d.addEventListener('click',function(e){e.preventDefault();go(k)})});
    // deslizar en celular
    var x0=null, m=$('.nv-card__media',c);
    m.addEventListener('touchstart',function(e){x0=e.touches[0].clientX},{passive:true});
    m.addEventListener('touchend',function(e){ if(x0===null) return; var dx=e.changedTouches[0].clientX-x0; if(Math.abs(dx)>40){go(dx<0?i+1:i-1)} x0=null; });
  });

  // Galería de producto en celular: puntos
  var gal=$('[data-nv-gal]');
  if(gal){
    var gd=$$('[data-nv-gdot]');
    gal.addEventListener('scroll',function(){ var k=Math.round(gal.scrollLeft/gal.clientWidth); gd.forEach(function(d,j){d.classList.toggle('is-on',j===k)}) },{passive:true});
    gd.forEach(function(d,j){d.addEventListener('click',function(){gal.scrollTo({left:j*gal.clientWidth,behavior:'smooth'})})});
  }

  // Ficha de producto: variantes
  var pj=$('[data-nv-product-json]');
  if(pj){
    var product=JSON.parse(pj.textContent), form=$('form.product-form'), idIn=$('[name="id"]',form);
    var btn=$('[data-add-to-cart]',form), priceEl=$('[data-nv-price]'), cuotaEl=$('[data-nv-cuota]'), lowEl=$('[data-nv-low]'), stickyP=$('[data-nv-sticky-price]');
    var money=function(c){return '$'+Math.round(c/100).toLocaleString('es-CL')};
    function current(){ var vals=$$('.nv-opt',form).map(function(fs){var c=$('input:checked',fs);return c?c.value:null}); return product.variants.find(function(v){return v.options.every(function(o,k){return o===vals[k]})}); }
    function update(){
      var v=current(); if(!v){ btn.disabled=true; btn.textContent='No disponible'; return; }
      idIn.value=v.id;
      var cmp=v.compare_at_price>v.price?' <s>'+money(v.compare_at_price)+'</s>':'';
      if(priceEl) priceEl.innerHTML=money(v.price)+cmp;
      if(stickyP) stickyP.textContent=money(v.price);
      if(cuotaEl) cuotaEl.textContent=money(Math.floor(v.price/300)*100);
      btn.disabled=!v.available; btn.textContent=v.available?'Agregar al carrito':'Agotado';
      $$('[data-nv-sticky-btn]').forEach(function(b){b.disabled=!v.available;b.textContent=btn.textContent});
      if(lowEl){ var q=v.inventory_quantity; lowEl.hidden=!(v.available && q>0 && q<=3 && v.inventory_management); if(!lowEl.hidden) lowEl.firstChild.textContent=(q===1?'Queda 1':'Quedan '+q)+' · '; }
      if(history.replaceState){ var u=new URL(location.href); u.searchParams.set('variant',v.id); history.replaceState({},'',u.toString()); }
      if(v.featured_media && gal){ var t=gal.querySelector('[data-media-id="'+v.featured_media.id+'"]'); if(t && window.innerWidth<900) gal.scrollTo({left:t.offsetLeft,behavior:'smooth'}); }
      $$('.nv-opt',form).forEach(function(fs){ var l=$('[data-nv-opt-sel]',fs), c=$('input:checked',fs); if(l&&c) l.textContent=c.value; });
    }
    form.addEventListener('change',function(e){ if(e.target.closest('.nv-opt')) update(); });
    // Barra fija en celular
    var st=$('[data-nv-sticky]');
    if(st && 'IntersectionObserver' in window){
      new IntersectionObserver(function(en){ st.classList.toggle('is-on',!en[0].isIntersecting && en[0].boundingClientRect.top<0) }).observe(btn);
      $$('[data-nv-sticky-btn]').forEach(function(b){b.addEventListener('click',function(){btn.click()})});
    }
  }
})();
